(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-slider"] && !Shopify.designMode) return;
  try {
    
class BannerSlider extends HTMLElement {
  constructor() {
    super();
    
    // The custom element tag is <m-slider>. Be robust to class changes.
    this.slider = this.querySelector('m-slider') || this;
    this.sliderInstance = null;
    
    this.initSlider();
    this.setupEventListeners();
  }
  
  initSlider() {
    if (typeof Swiper === 'undefined') {
      const script = document.createElement('script');
      script.src = 'https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.min.js';
      script.onload = () => this.initializeSwiper();
      document.head.appendChild(script);
      
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = 'https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.min.css';
      document.head.appendChild(link);
    } else {
      this.initializeSwiper();
    }
  }
  
  initializeSwiper() {
    // Prefer inline JSON options on the element if available
    let options = {};
    const inline = this.slider.getAttribute('data-slider-options');
    if (inline) {
      try { options = JSON.parse(inline); } catch(e) { options = {}; }
    }

    // Fallbacks from dataset on the component if not provided inline
    const ds = this.dataset || {};
    options.slidesPerView = options.slidesPerView || 1;
    options.spaceBetween = options.spaceBetween ?? parseInt(ds.spaceBetween || '0');
    options.loop = options.loop ?? (ds.loop === 'true');
    options.effect = options.effect || ds.effect || 'slide';

    if (options.autoplay === undefined) {
      const delay = parseInt(ds.autoplayTimeout || '5000');
      const enabled = ds.autoplay === 'true';
      options.autoplay = enabled ? { delay, disableOnInteraction: false } : false;
    }

    if (options.pagination === undefined) {
      const enabled = (ds.pagination === 'true') || (ds.dots === 'true');
      options.pagination = enabled ? { el: this.querySelector('.swiper-pagination'), clickable: true } : false;
    } else if (options.pagination && !options.pagination.el) {
      options.pagination.el = this.querySelector('.swiper-pagination');
    }

    if (options.navigation === undefined) {
      const enabled = (ds.navigation === 'true') || (ds.nav === 'true');
      options.navigation = enabled ? { nextEl: this.querySelector('.swiper-button-next'), prevEl: this.querySelector('.swiper-button-prev') } : false;
    } else if (options.navigation && (!options.navigation.nextEl || !options.navigation.prevEl)) {
      options.navigation.nextEl = options.navigation.nextEl || this.querySelector('.swiper-button-next');
      options.navigation.prevEl = options.navigation.prevEl || this.querySelector('.swiper-button-prev');
    }

    options.on = Object.assign({}, options.on, {
      init: () => { this.animateSlideContent(0); },
      slideChange: () => { this.animateSlideContent(this.sliderInstance.activeIndex); }
    });

    // Swiper must be initialized on the actual container element
    const container = this.querySelector('.swiper-container') || this.slider;
    this.sliderInstance = new Swiper(container, options);
  }
  
  animateSlideContent(slideIndex) {
    // Remove animation classes from all slides
    const allSlides = this.querySelectorAll('.swiper-slide');
    allSlides.forEach(slide => {
      const content = slide.querySelector('.m-banner-slider__content-inner');
      if (content) {
        content.classList.remove('fade-in', 'fade-in-up', 'fade-in-left', 'fade-in-right');
      }
    });
    
    // Add animation class to active slide content
    const activeSlide = allSlides[slideIndex];
    if (activeSlide) {
      const content = activeSlide.querySelector('.m-banner-slider__content-inner');
      if (content) {
        // Add a small delay to ensure the slide transition has started
        setTimeout(() => {
          content.classList.add('fade-in-up');
        }, 50);
      }
    }
  }
  
  setupEventListeners() {
    // Pause autoplay when hovering over the slider
    if (this.sliderInstance && this.sliderInstance.autoplay) {
      this.addEventListener('mouseenter', () => {
        if (this.sliderInstance.autoplay.running) {
          this.sliderInstance.autoplay.stop();
        }
      });
      
      this.addEventListener('mouseleave', () => {
        if (!this.sliderInstance.autoplay.running) {
          this.sliderInstance.autoplay.start();
        }
      });
    }
  }
}

customElements.define('m-slider', BannerSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dual-banner"] && !Shopify.designMode) return;
  try {
    
class DualBanner extends HTMLElement {
  constructor() {
    super();
    
    this.initializeAnimations();
  }
  
  initializeAnimations() {
    const items = this.querySelectorAll('.m-dual-banner__item');
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const content = entry.target.querySelector('.m-dual-banner__content-inner');
          if (content) {
            content.classList.add('fade-in-up');
          }
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1
    });
    
    items.forEach(item => {
      observer.observe(item);
    });
  }
}

customElements.define('m-dual-banner', DualBanner);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    class FAQController {
      constructor(root) {
        this.root = root;
        this.items = Array.from(root.querySelectorAll('.faq-item'));
        // read accordion mode from data attribute on the root (safer per-section)
        this.accordion = String(root.getAttribute('data-accordion')) === 'true';
        this.init();
      }

      init() {
        this.items.forEach(item => {
          const q = item.querySelector('.faq-question');
          if (!q) return;

          const handler = () => {
            if (this.accordion) this.toggleAccordion(item);
            else this.toggleSingle(item);
          };

          q.addEventListener('click', handler);
          q.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              handler();
            }
          });
        });

        if (this.accordion) this.normalizeDefaults();
      }

      normalizeDefaults() {
        let found = false;
        this.items.forEach(item => {
          if (item.classList.contains('active')) {
            if (!found) found = true;
            else this.close(item);
          }
        });
      }

      toggleAccordion(clicked) {
        const wasActive = clicked.classList.contains('active');
        this.items.forEach(i => { if (i !== clicked) this.close(i); });
        if (!wasActive) this.open(clicked); else this.close(clicked);
      }

      toggleSingle(item) {
        if (item.classList.contains('active')) this.close(item); else this.open(item);
      }

      open(item) {
        const q = item.querySelector('.faq-question');
        const a = item.querySelector('.faq-answer');
        item.classList.add('active');
        if (q) q.setAttribute('aria-expanded', 'true');
        if (a) {
          a.style.maxHeight = a.scrollHeight + 'px';
          a.style.paddingBottom = '{{ section.settings.answer_padding_bottom }}px';
          a.style.paddingLeft = '{{ section.settings.answer_padding_left_right }}px';
          a.style.paddingRight = '{{ section.settings.answer_padding_left_right }}px';
        }
        this.root.dispatchEvent(new CustomEvent('faq:opened', { detail: { item } }));
      }

      close(item) {
        const q = item.querySelector('.faq-question');
        const a = item.querySelector('.faq-answer');
        item.classList.remove('active');
        if (q) q.setAttribute('aria-expanded', 'false');
        if (a) {
          a.style.maxHeight = '0';
          a.style.paddingBottom = '0';
          a.style.paddingLeft = '{{ section.settings.answer_padding_left_right }}px';
          a.style.paddingRight = '{{ section.settings.answer_padding_left_right }}px';
        }
        this.root.dispatchEvent(new CustomEvent('faq:closed', { detail: { item } }));
      }
    }

    function initAll() {
      const nodes = document.querySelectorAll('.faq-section');
      nodes.forEach(node => {
        if (node.getAttribute('data-initialized')) return;
        new FAQController(node);
        node.setAttribute('data-initialized', 'true');
      });
    }

    document.addEventListener('DOMContentLoaded', initAll);
    if (typeof Shopify !== 'undefined') document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-grid-with-content"] && !Shopify.designMode) return;
  try {
    
class ImageGridWithContent extends HTMLElement {
  constructor() {
    super();
    
    this.initializeAnimations();
  }
  
  initializeAnimations() {
    const content = this.querySelector('.m-image-grid-with-content__content');
    const gridItems = this.querySelectorAll('.m-image-grid-with-content__grid-item');
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (entry.target.classList.contains('m-image-grid-with-content__content')) {
            entry.target.classList.add('fade-in-up');
          } else {
            entry.target.style.opacity = '0';
            entry.target.style.transform = 'translateY(20px)';
            
            const delay = parseInt(entry.target.getAttribute('data-index') || '0') * 0.1;
            
            setTimeout(() => {
              entry.target.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
              entry.target.style.opacity = '1';
              entry.target.style.transform = 'translateY(0)';
            }, delay * 1000);
          }
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1
    });
    
    if (content) {
      observer.observe(content);
    }
    
    gridItems.forEach((item, index) => {
      item.setAttribute('data-index', index);
      observer.observe(item);
    });
  }
}

customElements.define('m-image-grid-with-content', ImageGridWithContent);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["info-cards"] && !Shopify.designMode) return;
  try {
    
class InfoCards extends HTMLElement {
  constructor() {
    super();
    
    this.initializeAnimations();
  }
  
  initializeAnimations() {
    const items = this.querySelectorAll('.m-info-cards__item');
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry, index) => {
        if (entry.isIntersecting) {
          // Add a delay based on the item's position
          const delay = index * 100; // 100ms delay between each item
          
          setTimeout(() => {
            entry.target.classList.add('animate-in');
          }, delay);
          
          // Stop observing this item once it's been animated
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });
    
    items.forEach(item => {
      observer.observe(item);
    });
    
    // Apply custom colors from block settings
    this.applyCustomColors();
  }
  
  applyCustomColors() {
    const cards = this.querySelectorAll('.m-info-cards__card[data-block-id]');
    
    cards.forEach(card => {
      const blockId = card.getAttribute('data-block-id');
      const blockSettings = this.getBlockSettings(blockId);
      
      if (blockSettings) {
        // Apply custom colors as CSS variables
        if (blockSettings.card_bg_color) {
          card.style.setProperty('--card-bg-color', blockSettings.card_bg_color);
        }
        
        if (blockSettings.card_text_color) {
          card.style.setProperty('--card-text-color', blockSettings.card_text_color);
        }
        
        if (blockSettings.icon_bg_color) {
          card.style.setProperty('--icon-bg-color', blockSettings.icon_bg_color);
        }
        
        if (blockSettings.icon_color) {
          card.style.setProperty('--icon-color', blockSettings.icon_color);
        }
      }
    });
  }
  
  getBlockSettings(blockId) {
    // This would be populated with the actual block settings from the theme editor
    // For now, it returns an empty object
    return {};
  }
}

customElements.define('m-info-cards', InfoCards);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-loactions-strip"] && !Shopify.designMode) return;
  try {
    
(function() {
  const section = document.querySelector('.shop-locations-strip');
  if (!section) return;
  
  // Open modal
  section.querySelectorAll('.sls__trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const modalId = trigger.dataset.modalId;
      const modal = document.getElementById(modalId);
      if (modal) {
        modal.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        
        // Focus trap
        const focusableElements = modal.querySelectorAll('button, a, input, [tabindex]:not([tabindex="-1"])');
        if (focusableElements.length) focusableElements[0].focus();
      }
    });
  });
  
  // Close modal
  document.querySelectorAll('.sls-modal').forEach(modal => {
    // Close button and backdrop
    modal.querySelectorAll('[data-modal-close]').forEach(closeBtn => {
      closeBtn.addEventListener('click', () => {
        modal.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    });
    
    // ESC key
    modal.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        modal.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
